import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';

import Styled from 'styled';

import Modal from 'four-nets/ui-v2/modal/modal';
import UserGridListView from 'four-nets/user/user-grid-list-view';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import PagerView from 'four-nets/ui/pager-view';

import defaultStyles from './user-grid-list-stack-view.scss';

@Styled(defaultStyles)
@observer
class UserGridListStackView extends React.Component {
    @observable error: ?Error;
    loadPromise: ?Promise<any>;

    componentDidUpdate(prevProps) {
        if (prevProps.open === false && this.props.open === true) {
            this.load();
        }
    }

    componentWillUnmount() {
        if (this.loadPromise) {
            this.loadPromise.cancel();
        }
    }

    loadDidFail = err => {
        this.error = err;
    };

    load = () => {
        this.error = null;
        this.loadPromise = this.props.userGridListViewModel.load().catch(this.loadDidFail);
    };

    onClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }

        if (this.loadPromise) {
            this.loadPromise.cancel();
        }
    };

    loadPage = (event, page) => {
        this.props.userGridListViewModel.loadPage(page).catch(this.loadDidFail);
    };

    render() {
        const { styles, intlManager, open, title, userGridListViewModel } = this.props;

        return (
            <Modal title={title} open={open} onClose={this.onClose}>
                <div className={styles.gridList}>
                    {userGridListViewModel ? (
                        <LoadingWrapperView
                            loading={userGridListViewModel.loading}
                            error={this.error}
                            retry={this.load}
                        >
                            <UserGridListView userGridListViewModel={userGridListViewModel} />
                            {userGridListViewModel.pagedResult ? (
                                <PagerView
                                    count={userGridListViewModel.pagedResult.pages}
                                    current={userGridListViewModel.pagedResult.page}
                                    onPage={this.loadPage}
                                    linkify={false}
                                />
                            ) : null}
                        </LoadingWrapperView>
                    ) : null}
                </div>
            </Modal>
        );
    }
}

export default UserGridListStackView;
